"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propagateHeightAlt = exports.propagateHeight = void 0;
//This function is used for call the parent application and fit a good width and height
//Markenkliq is a catalog for being used in an iframe, for this reason we have to communicate with the parent for setup dimensions and avoid scroll bars
//The idea is to call this function each time there is a change in the content that affect the height
function propagateHeight(resetScroll) {
    var message = {
        height: (document.body.scrollHeight + 20) + 'px',
        width: '100%',
        resetScroll: false
    };
    message.resetScroll = resetScroll;
    if (parseInt(message.height) < 600) {
        message.height = '600px';
    }
    // window.top refers to parent window
    window.top.postMessage(message, "*");
}
exports.propagateHeight = propagateHeight;
;
window.propagateHeight = propagateHeight;
function propagateHeightAlt(resetScroll) {
    var message = {
        height: (Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + 20) + 'px',
        width: '100%',
        resetScroll: false
    };
    message.resetScroll = resetScroll;
    if (parseInt(message.height) < 600) {
        message.height = '600px';
    }
    // window.top refers to parent window
    window.top.postMessage(message, "*");
}
exports.propagateHeightAlt = propagateHeightAlt;
;
